import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Carousel from './components/Carousel';
import Footer from './components/Footer';
import Fact from './components/Fact';
import About from './components/About';
import Services from './components/Services';
import Project from './components/Project';
import Team from './components/team/Team';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import WebDevelopment from './components/WebDevelopment';
import AppDevelopment from './components/AppDevelopment';
import Internship from './components/internship/Internship';
import InternshipOffers from './components/internship/internships';
import PageHeader from './components/PageHeader';
import VerificationSection from './components/Verification/VerificationSection'
import VerifyCertificate from './components/Verification/VerifyCertificate';
import BackToTop from './components/BackToTop';
import Job from './components/Job';
import FocusArea from './components/Focusarea';
import StudenttrainingCourse from './components/training/StudenttrainingCourse';
import InternshipProgramDetail from './components/internship/InternshipProgramDetail';


function App() {
  return (
    <Router>
      <Topbar />
      <Navbar/>
      <Routes>
        <Route path="/" element={<> <Carousel/><Fact /><About /> <FocusArea/>  <Services/> <Project/>  <Team/><Testimonial/><Contact/> </>} />


        {/* <StudenttrainingCourse/> */}
         {/* <InternshipProgramDetail/> */}


        <Route path="/web-devlopment" element={<><PageHeader title="Web development"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Web development" }]}/><Fact/><WebDevelopment/></>} />
       
       
        <Route path="/app-devlopment" element={<><PageHeader title="App Development"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "App Development" }]}/> <Fact/>   <AppDevelopment/></>} />
       
       
        <Route path="/projects" element={<> <PageHeader title="Products"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Products" }]}/><Fact/>     <Project/></>} />
        
        
        
        {/* <Route path="/internship" element={<><PageHeader title="Internship"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Internship" }]}/><Fact/>   <Internship/> <InternshipOffers/><Team/> </>} />
        */}
       
       
        <Route path="/jobs" element={<><PageHeader title="Jobs"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Jobs" }]}/><Fact/> <Job/>  </>} />
       
       
       
        {/* <Route path="/verification" element={<><PageHeader title="Verification"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Verification" }]}/><Fact/> <VerificationSection/> </>} />
        */}
       
       
       
         {/* <Route path="/verify" element={<><PageHeader title="Verify"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Verify" }]}/><Fact/> <VerifyCertificate/> </>} /> */}
       
       
       
        <Route path="/about" element={<> <PageHeader title="About"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "About" }]}/>  <Fact/><About/></>} />
        <Route path="/contact" element={<><PageHeader title="Contact"breadcrumbs={[{ label: "Home", link: "/" },{ label: "Pages", link: "/pages" },{ label: "Contact" }]}/><Fact/><Contact/></>} />

        
        {/* Add more routes here */}
      </Routes>

      <Footer/>

      <BackToTop/>
      
    </Router>
  );
}

export default App;
